import { useState } from 'react';
import { ImagePlus } from 'lucide-react';
import { usePageContent } from '@/context/SiteDataContext';
import { useEditMode } from '@/context/EditModeContext';
import EditText from '@/components/editable/EditText';
import HeroEditorDialog, { heroImgStyle } from '@/components/editable/HeroEditorDialog';

const HEIGHTS = { sm: 'py-16', md: 'py-24', lg: 'py-36' };

export default function PageHero({ slug, overline, heading, text, defaultImage = '', children }) {
  const c = usePageContent(slug);
  const { editMode } = useEditMode();
  const [open, setOpen] = useState(false);
  const img = c.hero_bg_image !== undefined ? c.hero_bg_image : defaultImage;
  const bodyText = c.hero_text || text;

  return (
    <section data-testid={`page-hero-${slug}`}
      className={`relative text-white overflow-hidden ${HEIGHTS[c.hero_height] || HEIGHTS.md} ${c.hero_bg_color ? '' : 'bg-royal'}`}
      style={c.hero_bg_color ? { backgroundColor: c.hero_bg_color } : undefined}>
      {img && (
        <div className="absolute inset-0 overflow-hidden">
          <img src={img} alt="" className="w-full h-full object-cover" style={heroImgStyle(c.hero_bg_zoom, c.hero_bg_x, c.hero_bg_y)} />
          <div className="absolute inset-0" style={{ backgroundColor: c.hero_overlay_color || 'var(--royal, #3B1E5E)', opacity: c.hero_overlay_opacity ?? 0.8 }} />
        </div>
      )}
      {editMode && (
        <button onClick={() => setOpen(true)} data-testid={`edit-hero-${slug}`}
          className="absolute top-3 right-3 z-20 inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gold text-royal-dark text-xs font-bold shadow-lg">
          <ImagePlus className="w-3.5 h-3.5" /> Edit Header
        </button>
      )}
      <div className="relative max-w-5xl mx-auto px-6 text-center">
        <EditText field="hero_overline" target={`page:${slug}`} as="div" className="overline text-gold mb-4">{c.hero_overline || overline}</EditText>
        <EditText field="hero_heading" target={`page:${slug}`} as="h1" className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold">{c.hero_heading || heading}</EditText>
        {(bodyText || editMode) && (
          <EditText field="hero_text" target={`page:${slug}`} as="p" multiline className="mt-6 text-white/85 text-lg max-w-3xl mx-auto">{bodyText || 'Add a subtitle'}</EditText>
        )}
        {children}
      </div>
      {open && <HeroEditorDialog slug={slug} content={c} defaultImage={defaultImage} onClose={() => setOpen(false)} />}
    </section>
  );
}
